import _slicedToArray from "/var/www/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "/var/www/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _defineProperty from "/var/www/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var __jsx = React.createElement;
import _regeneratorRuntime from "/var/www/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
/* eslint-disable react/no-array-index-key */
import React
// { useEffect } 
from 'react';
import { useRouter } from 'next/router';
import styled from 'styled-components';
import {
// useMutation, 
useQuery } from '@apollo/client';
import { Container, Grid } from '@mui/material';
import { makeStyles } from '@mui/styles';
import Spacer from '@atoms/Spacer';
import Typography from '@atoms/Typography';
import OpportunitySeo from '@molecules/SEO/OpportunitySeo';
import Footer from '@organisms/common/Footer';
import FeaturedSlider from '@organisms/common/FeaturedSlider';
import OpportunityDetailsTemplate from '@templates/OpportunityDetails';
import ViewOpportunity from '@organisms/opportunities/ViewOpportunity';
import GeneralFields from '@app/components/organisms/opportunity-wizard/WizardForm/GeneralFields';
import { SEARCH_OPPORTUNITY, VIEW_OPPORTUNITY
// GET_ORGANISATION_DETAILS,
} from '@app/apollo/queries';
import { useTranslation } from '@app/config/i18n';
import { deviceSizes } from '@app/config/devices';
import { addApolloState, initializeApollorWithQueries } from '@app/config/apollo';
// import { TRACK_OPPORTUNITY_VIEWS } from '@app/apollo/mutations';
import { OPP_STATUS_ENUM } from '@app/constants';
import HeaderSidebar1Col from '@app/components/templates/HeaderSidebar1Col';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var OpportunityContainer = styled.div.withConfig({
  displayName: "view__OpportunityContainer",
  componentId: "sc-1k42lmy-0"
})(["background-color:", ";padding:4rem;h5{padding:0 0 1rem 0.5rem;}@media (max-width:", "){padding:1rem;h5{padding:2rem 0 2rem 1rem;}}"], function (_ref) {
  var theme = _ref.theme;
  return theme.secondaryColor[200];
}, deviceSizes.tablet);
export var useClasses = makeStyles({
  CardContanerStyle: _defineProperty({
    paddingLeft: '1rem ',
    paddingRight: '1rem',
    paddingBottom: '0.5rem',
    height: '100%'
  }, "@media only screen and (min-width: ".concat(deviceSizes.mobileL, ") and (max-width: 550px})"), {
    paddingLeft: '2rem',
    paddingRight: '2rem'
  })
});
var responsive = {
  desktop: {
    breakpoint: {
      max: 3000,
      min: 1024
    },
    items: 3,
    slidesToSlide: 1 // optional, default to 1.
  },
  tablet: {
    breakpoint: {
      max: 1024,
      min: 550
    },
    items: 2,
    slidesToSlide: 1 // optional, default to 1.
  },
  mobile: {
    breakpoint: {
      max: 550,
      min: 0
    },
    items: 1,
    slidesToSlide: 1 // optional, default to 1.
  }
};
var OpportunityViewPage = function OpportunityViewPage(_ref2) {
  var _opportunity$logo, _opportunity$organisa;
  var opportunity = _ref2.opportunity;
  var _useTranslation = useTranslation('common'),
    t = _useTranslation.t;
  var isDraft = (opportunity === null || opportunity === void 0 ? void 0 : opportunity.is_draft) || (opportunity === null || opportunity === void 0 ? void 0 : opportunity.opp_status) === OPP_STATUS_ENUM.DRAFT;

  // const classes = useClasses()

  var router = useRouter();
  var slug = router.query.slug;
  if (!opportunity) {
    return /*#__PURE__*/_jsx(HeaderSidebar1Col, {
      children: /*#__PURE__*/_jsx(Container, {
        style: {
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '74vh'
        },
        children: /*#__PURE__*/_jsx(Typography, {
          variant: "h4",
          color: "error",
          style: {
            textAlign: 'center'
          },
          children: t('request_not_available_try_another')
        })
      })
    });
  }

  // const [trackViewsMutation, { loading: trackViewsLoading, error: trackViewsError }] = 
  //   useMutation(TRACK_OPPORTUNITY_VIEWS);

  // // Get user IP function (this is just a simplified example)
  // const getUserIP = async () => {
  //   const response = await fetch('https://api.ipify.org?format=json');
  //   const data = await response.json();
  //   return data.ip;
  // };

  // useEffect(() => {
  //   // getUserIP();
  //   trackViewsMutation({
  //     variables: {
  //       slug,
  //       ip: 'userIP',
  //     },
  //   });
  // }, []);

  var _useQuery = useQuery(SEARCH_OPPORTUNITY, {
      variables: {
        input: {
          upcoming: true,
          organisation: opportunity === null || opportunity === void 0 ? void 0 : (_opportunity$organisa = opportunity.organisation) === null || _opportunity$organisa === void 0 ? void 0 : _opportunity$organisa.slug,
          ignore_opportunities: [opportunity === null || opportunity === void 0 ? void 0 : opportunity.id]
        },
        first: 4
      }
      // skip: opportunityLoading || !opportunity?.organisation?.slug,
    }),
    _useQuery$data = _useQuery.data;
  _useQuery$data = _useQuery$data === void 0 ? {} : _useQuery$data;
  var _useQuery$data$opport = _useQuery$data.opportunitySearch;
  _useQuery$data$opport = _useQuery$data$opport === void 0 ? {} : _useQuery$data$opport;
  var _useQuery$data$opport2 = _useQuery$data$opport.data,
    opportunities = _useQuery$data$opport2 === void 0 ? [] : _useQuery$data$opport2,
    searchLoading = _useQuery.loading;
  return /*#__PURE__*/_jsx(_Fragment, {
    children: isDraft || searchLoading ? /*#__PURE__*/_jsx(HeaderSidebar1Col, {
      children: Array.from(new Array(5)).map(function (e, i) {
        return /*#__PURE__*/_jsx(GeneralFields.Skeleton, {}, "skeleton-".concat(i));
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [opportunity && /*#__PURE__*/_jsx(OpportunitySeo, {
        opportunity: opportunity
      }), /*#__PURE__*/_jsx(OpportunityDetailsTemplate, {
        opportunity: opportunity,
        background: opportunity && (opportunity === null || opportunity === void 0 ? void 0 : opportunity.logo) && (opportunity === null || opportunity === void 0 ? void 0 : (_opportunity$logo = opportunity.logo) === null || _opportunity$logo === void 0 ? void 0 : _opportunity$logo.path),
        children: opportunity && /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(Container, {
            children: /*#__PURE__*/_jsxs(Grid, {
              container: true,
              justifyContent: "center",
              children: [/*#__PURE__*/_jsx(Grid, {
                item: true,
                lg: 7,
                sm: 10,
                md: 9,
                xs: 12,
                children: /*#__PURE__*/_jsx(ViewOpportunity, {
                  slug: slug,
                  opportunity: opportunity,
                  loading: false
                })
              }), /*#__PURE__*/_jsx(Spacer, {
                height: "2rem"
              })]
            })
          }), /*#__PURE__*/_jsx(Spacer, {
            height: "4rem"
          }), opportunities.length > 0 && /*#__PURE__*/_jsx(OpportunityContainer, {
            children: /*#__PURE__*/_jsx(Grid, {
              container: true,
              justify: "center",
              alignItems: "center",
              children: /*#__PURE__*/_jsxs(Grid, {
                item: true,
                lg: 9,
                md: 9,
                xs: 12,
                sm: 12,
                children: [/*#__PURE__*/_jsx(Typography, {
                  variant: "h5",
                  children: t('similar_organiser')
                }), /*#__PURE__*/_jsx(FeaturedSlider, {
                  opportunities: opportunities,
                  responsivnes: responsive
                })]
              })
            })
          }), /*#__PURE__*/_jsx(Footer, {})]
        })
      })]
    })
  });
};
export function getServerSideProps(_x) {
  return _getServerSideProps.apply(this, arguments);
}
function _getServerSideProps() {
  _getServerSideProps = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(ctx) {
    var slug, _yield$initializeApol, apolloClient, _yield$initializeApol2, _yield$initializeApol3, opportunity;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            slug = ctx.query.slug;
            _context.prev = 1;
            _context.next = 4;
            return initializeApollorWithQueries(ctx, [{
              query: VIEW_OPPORTUNITY,
              variables: {
                slug: slug
              }
            }]);
          case 4:
            _yield$initializeApol = _context.sent;
            apolloClient = _yield$initializeApol.apolloClient;
            _yield$initializeApol2 = _slicedToArray(_yield$initializeApol.data, 1);
            _yield$initializeApol3 = _yield$initializeApol2[0];
            _yield$initializeApol3 = _yield$initializeApol3 === void 0 ? {} : _yield$initializeApol3;
            opportunity = _yield$initializeApol3.opportunity; // Check if the data is null or has errors
            if (!(!opportunity || opportunity === null)) {
              _context.next = 12;
              break;
            }
            return _context.abrupt("return", {
              notFound: true // Show Next.js 404 page
            });
          case 12:
            return _context.abrupt("return", addApolloState(apolloClient, {
              props: {
                opportunity: opportunity,
                namespacesRequired: ['common', 'dashboard', 'wizard', 'applications']
              }
            }));
          case 15:
            _context.prev = 15;
            _context.t0 = _context["catch"](1);
            console.error('SSR error in getServerSideProps:', _context.t0);

            // You can choose to return a fallback page here too
            return _context.abrupt("return", {
              props: {
                error: 'Internal Server Error'
              }
            });
          case 19:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 15]]);
  }));
  return _getServerSideProps.apply(this, arguments);
}
OpportunityViewPage.defaultProps = {
  opportunity: null
};
export default OpportunityViewPage;